import React from 'react';
import ReactMoment from 'react-moment';
import styled from 'styled-components';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';
import {GetCardTypeForBody} from '../../../../../util/utils';

function PrintViewDatePickerBody(props) {
	const {body} = props;
	const useFormat = 'YYYY-MM-DD';
	const formBodyBorder = GetCardTypeForBody(body);

	return (
		<StyledPrintViewDatePickerBody className={`StyledPrintViewDatePickerBody ${formBodyBorder}`}>
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
			<section className="SectionBodyData PrintViewDatePickerBodyData">
				<section className="date-body-value">
					{<ReactMoment format={useFormat}>{body.bodyFreeText}</ReactMoment>}
				</section>
			</section>
		</StyledPrintViewDatePickerBody>
	);
}

const StyledPrintViewDatePickerBody = styled.section`
	display: block;
	.SectionBodyData {
		margin-top: var(--px-10);
		display: block !important;
	}
	.date-body-value {
		margin-top: var(--px-5);
		padding: var(--px-1) var(--px-6);
		max-width: var(--px-150);
		min-height: var(--px-25);
		border: var(--px-1) solid var(--neutrals-300) !important;
	}
`;

export default PrintViewDatePickerBody;
